/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import Tysiav2Launch from 'DesignSystem/Svgs/Tysiav2Launch/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/CreateTreatmentPlan/EditTreatmentAndPaymentPlans/New/Header"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Header.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 weight="semibold"
 color={dtColorsNeutral900}
 marginBottom={dtSpaceXxs}
 text="New Treatment"
/>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral500}
 text="Select a treatment plan, compare plans and plan payment for the patient."
/>
<div
  data-testid="Header.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 size="normal"
 color={dtColorsNeutral500}
 text="Learn how this works"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../SignIn'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../SignIn'))}
/>
<Tysiav2Launch
  viewPath={`${viewPath}/Tysiav2Launch`}
 width={16}
 height={16}
 marginLeft="auto"
 stroke={dtColorsNeutral500}
/>
</div>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceS}
 marginBottom={0}
/>
</div>
{children}
</React.Fragment>)
}